/* Salt of Life PDP — buy box, gallery, sticky bar.
   Reads product JSON rendered by sections/salt-of-life-buy-box.liquid.
   No dependencies; works on Dawn and any Online Store 2.0 theme. */
(function () {
  "use strict";

  // Handles every shop.money_format placeholder Shopify emits, not just {{amount}},
  // so non-USD / comma-separator stores render correct prices instead of falling back.
  function money(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format && format.match(placeholder);
    if (!match) return "$" + (cents / 100).toFixed(2);

    var name = match[1];
    var decimals = name.indexOf("no_decimals") === -1 ? 2 : 0;
    var thousands = ",";
    var decimalMark = ".";
    if (name.indexOf("comma_separator") !== -1) { thousands = "."; decimalMark = ","; }
    else if (name.indexOf("apostrophe_separator") !== -1) { thousands = "'"; }
    else if (name.indexOf("space_separator") !== -1) { thousands = " "; }

    var parts = (cents / 100).toFixed(decimals).split(".");
    var value = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    if (parts[1]) value += decimalMark + parts[1];

    // money_format can contain markup (e.g. <span class="money">); we render via
    // textContent, so strip tags rather than showing them literally.
    return format.replace(placeholder, value).replace(/<[^>]+>/g, "").trim();
  }

  function initGallery(root) {
    var main = root.querySelector("[data-sol-main-image]");
    if (!main) return;
    root.querySelectorAll("[data-sol-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        root.querySelectorAll("[data-sol-thumb]").forEach(function (t) {
          t.setAttribute("aria-current", "false");
        });
        thumb.setAttribute("aria-current", "true");
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt || "";
      });
    });
  }

  function initBuyBox(root) {
    var dataEl = root.querySelector("[data-sol-product-json]");
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var moneyFormat = data.money_format;
    var sellingPlanId = data.selling_plan_id; // null when no subscription plan exists
    var discount = data.subscription_discount || 0; // fallback %, used only for display when plan price unknown

    var form = root.querySelector("form.sol-productform");
    var variantInput = root.querySelector("[data-sol-variant-input]");
    var planInput = root.querySelector("[data-sol-selling-plan-input]");
    var qtyInput = root.querySelector("[data-sol-qty-input]");
    var qtyOutput = root.querySelector("[data-sol-qty-output]");
    var atc = root.querySelector("[data-sol-atc]");
    var stickyPrice = document.querySelector("[data-sol-sticky-price]");
    var stickyLabel = document.querySelector("[data-sol-sticky-label]");

    var state = {
      variant: variants.filter(function (v) { return v.available; })[0] || variants[0],
      subscribe: Boolean(sellingPlanId),
      qty: 1
    };

    function subscriptionPrice(variant) {
      if (variant.selling_plan_price != null) return variant.selling_plan_price;
      return Math.round(variant.price * (1 - discount));
    }

    function unitPrice() {
      return state.subscribe ? subscriptionPrice(state.variant) : state.variant.price;
    }

    function render() {
      root.querySelectorAll("[data-sol-size]").forEach(function (btn) {
        btn.setAttribute("aria-pressed", String(Number(btn.dataset.variantId) === state.variant.id));
      });
      root.querySelectorAll("[data-sol-plan]").forEach(function (btn) {
        var isSub = btn.dataset.solPlan === "subscribe";
        btn.setAttribute("aria-pressed", String(isSub === state.subscribe));
        var priceEl = btn.querySelector("[data-sol-plan-price]");
        if (priceEl) priceEl.textContent = money(isSub ? subscriptionPrice(state.variant) : state.variant.price, moneyFormat);
        var compareEl = btn.querySelector("[data-sol-plan-compare]");
        if (compareEl) compareEl.textContent = money(state.variant.price, moneyFormat);
      });

      variantInput.value = state.variant.id;
      if (planInput) planInput.value = state.subscribe && sellingPlanId ? sellingPlanId : "";
      qtyInput.value = state.qty;
      qtyOutput.textContent = state.qty;

      var total = unitPrice() * state.qty;
      atc.disabled = !state.variant.available;
      atc.textContent = state.variant.available
        ? "Add to cart — " + money(total, moneyFormat)
        : "Sold out";
      if (stickyPrice) stickyPrice.textContent = money(total, moneyFormat);
      if (stickyLabel) stickyLabel.textContent = state.variant.title;

      // Keep the URL in sync so shares/refreshes land on the right variant.
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", state.variant.id);
        window.history.replaceState({}, "", url.toString());
      }
    }

    root.querySelectorAll("[data-sol-size]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var found = variants.filter(function (v) { return v.id === Number(btn.dataset.variantId); })[0];
        if (found) { state.variant = found; render(); }
      });
    });

    root.querySelectorAll("[data-sol-plan]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.subscribe = btn.dataset.solPlan === "subscribe" && Boolean(sellingPlanId);
        render();
      });
    });

    var dec = root.querySelector("[data-sol-qty-dec]");
    var inc = root.querySelector("[data-sol-qty-inc]");
    if (dec) dec.addEventListener("click", function () { state.qty = Math.max(1, state.qty - 1); render(); });
    if (inc) inc.addEventListener("click", function () { state.qty += 1; render(); });

    function addToCart() {
      var body = {
        items: [{ id: state.variant.id, quantity: state.qty }]
      };
      if (state.subscribe && sellingPlanId) body.items[0].selling_plan = sellingPlanId;

      atc.disabled = true;
      return fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body)
      })
        .then(function (res) { return res.json().then(function (json) { if (!res.ok) throw json; return json; }); })
        .then(function () {
          document.dispatchEvent(new CustomEvent("sol:added", { detail: { variant: state.variant } }));
          // Refresh theme cart drawer / bubble when the theme exposes one.
          var drawer = document.querySelector("cart-drawer");
          if (drawer && typeof drawer.open === "function") {
            return fetch(window.Shopify.routes.root + "?sections=cart-drawer,cart-icon-bubble")
              .then(function (r) { return r.json(); })
              .then(function (sections) {
                if (typeof drawer.renderContents === "function") {
                  drawer.renderContents({ sections: sections });
                } else {
                  drawer.open();
                }
              });
          }
          window.location.href = window.Shopify.routes.root + "cart";
        })
        .catch(function (err) {
          console.error("[salt-of-life] add to cart failed", err);
          alert((err && err.description) || "Sorry, that could not be added to your cart.");
        })
        .then(function () { atc.disabled = false; render(); });
    }

    if (form) {
      form.addEventListener("submit", function (e) { e.preventDefault(); addToCart(); });
    }
    var stickyBtn = document.querySelector("[data-sol-sticky-atc]");
    if (stickyBtn) stickyBtn.addEventListener("click", addToCart);

    // Honour ?variant= on load.
    var initial = new URL(window.location.href).searchParams.get("variant");
    if (initial) {
      var match = variants.filter(function (v) { return v.id === Number(initial); })[0];
      if (match) state.variant = match;
    }

    render();
  }

  // Guard so a theme-editor section reload doesn't double-bind listeners on
  // sections that are already wired up.
  function once(fn) {
    return function (el) {
      if (el.dataset.solInit === "true") return;
      el.dataset.solInit = "true";
      fn(el);
    };
  }

  function init() {
    document.querySelectorAll("[data-sol-gallery]").forEach(once(initGallery));
    document.querySelectorAll("[data-sol-buybox]").forEach(once(initBuyBox));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-init after Theme Editor section reloads.
  document.addEventListener("shopify:section:load", init);
})();
